import React from 'react';
import logo from './logo.svg';
import './App.css';
import Header from './components/header.js';
import Footer from './components/footer.js';


function App() {
  //header 
  //content
  //footer
  return (
    <div className="App">
      <header className="App-header">
      <Header/>
      </header>
    </div>
  );
}

export default App;
